import { X, FileText, Download } from "lucide-react";
import { API_BASE } from "../../lib/api";

export function FilePreviewModal({ file, onClose }) {
  const url = file.pdf_url ? `${API_BASE}${file.pdf_url}` : `${API_BASE}/files/${file.storage_path}`;
  return (
    <div className="fixed inset-0 z-[70] bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="file-preview-modal">
      <div className="bg-background rounded-lg border border-border w-full max-w-4xl h-[85vh] flex flex-col overflow-hidden" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2 px-3 h-11 border-b border-border shrink-0">
          <FileText size={15} className="text-muted-foreground" />
          <span className="text-sm font-medium truncate flex-1" data-testid="preview-filename">{file.filename}</span>
          <a data-testid="preview-download" href={url} target="_blank" rel="noreferrer"
            className="h-7 w-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"><Download size={15} /></a>
          <button data-testid="preview-close" onClick={onClose}
            className="h-7 w-7 flex items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"><X size={16} /></button>
        </div>
        {file.content_type?.startsWith("image/") ? (
          <div className="flex-1 min-h-0 flex items-center justify-center bg-muted/30 p-2">
            <img src={url} alt={file.filename} className="max-h-full max-w-full object-contain" data-testid="preview-image" />
          </div>
        ) : (
          <iframe src={url} title={file.filename} className="flex-1 w-full min-h-0 bg-white" data-testid="preview-pdf" />
        )}
      </div>
    </div>
  );
}

export function AttachmentChip({ att, onPreview }) {
  if (att.content_type?.startsWith("image/")) {
    return (
      <button data-testid={`chat-image-${att.id || att.storage_path}`} onClick={() => onPreview(att)} className="block">
        <img src={`${API_BASE}/files/${att.storage_path}`} alt={att.filename}
          className="max-w-[220px] max-h-[160px] rounded-md border border-border object-cover hover:opacity-90 transition-opacity" />
      </button>
    );
  }
  return (
    <button data-testid={`chat-file-${att.id || att.storage_path}`} onClick={() => onPreview(att)}
      className="flex items-center gap-2 px-2.5 py-2 rounded-md border border-border bg-background hover:bg-muted transition-colors max-w-[260px]">
      <FileText size={16} className="text-[#E31E24] shrink-0" />
      <span className="text-xs font-medium truncate">{att.filename}</span>
      <span className="text-[10px] text-muted-foreground shrink-0 uppercase">PDF</span>
    </button>
  );
}
